// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file service/admin/crud/maintenance_crud_service_generated.proto (package service, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Maintenance } from "../../../entity/maintenance_pb";

/**
 * IndexMaintenanceArgs メッセージ
 *
 * @generated from message service.IndexMaintenanceArgs
 */
export class IndexMaintenanceArgs extends Message<IndexMaintenanceArgs> {
  /**
   * @generated from field: int32 offset = 1;
   */
  offset = 0;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  constructor(data?: PartialMessage<IndexMaintenanceArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.IndexMaintenanceArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "offset", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IndexMaintenanceArgs {
    return new IndexMaintenanceArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IndexMaintenanceArgs {
    return new IndexMaintenanceArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IndexMaintenanceArgs {
    return new IndexMaintenanceArgs().fromJsonString(jsonString, options);
  }

  static equals(a: IndexMaintenanceArgs | PlainMessage<IndexMaintenanceArgs> | undefined, b: IndexMaintenanceArgs | PlainMessage<IndexMaintenanceArgs> | undefined): boolean {
    return proto3.util.equals(IndexMaintenanceArgs, a, b);
  }
}

/**
 * CreateMaintenanceArgs メッセージ
 *
 * @generated from message service.CreateMaintenanceArgs
 */
export class CreateMaintenanceArgs extends Message<CreateMaintenanceArgs> {
  /**
   * @generated from field: repeated entity.Maintenance maintenances = 1;
   */
  maintenances: Maintenance[] = [];

  /**
   * @generated from field: bool force_execute = 2 [json_name = "force_execute"];
   */
  forceExecute = false;

  /**
   * @generated from field: bool skip_version_migration = 3 [json_name = "skip_version_migration"];
   */
  skipVersionMigration = false;

  constructor(data?: PartialMessage<CreateMaintenanceArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.CreateMaintenanceArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "maintenances", kind: "message", T: Maintenance, repeated: true },
    { no: 2, name: "force_execute", jsonName: "force_execute", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "skip_version_migration", jsonName: "skip_version_migration", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateMaintenanceArgs {
    return new CreateMaintenanceArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateMaintenanceArgs {
    return new CreateMaintenanceArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateMaintenanceArgs {
    return new CreateMaintenanceArgs().fromJsonString(jsonString, options);
  }

  static equals(a: CreateMaintenanceArgs | PlainMessage<CreateMaintenanceArgs> | undefined, b: CreateMaintenanceArgs | PlainMessage<CreateMaintenanceArgs> | undefined): boolean {
    return proto3.util.equals(CreateMaintenanceArgs, a, b);
  }
}

/**
 * ReadMaintenanceArgs メッセージ
 *
 * @generated from message service.ReadMaintenanceArgs
 */
export class ReadMaintenanceArgs extends Message<ReadMaintenanceArgs> {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[] = [];

  constructor(data?: PartialMessage<ReadMaintenanceArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.ReadMaintenanceArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReadMaintenanceArgs {
    return new ReadMaintenanceArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReadMaintenanceArgs {
    return new ReadMaintenanceArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReadMaintenanceArgs {
    return new ReadMaintenanceArgs().fromJsonString(jsonString, options);
  }

  static equals(a: ReadMaintenanceArgs | PlainMessage<ReadMaintenanceArgs> | undefined, b: ReadMaintenanceArgs | PlainMessage<ReadMaintenanceArgs> | undefined): boolean {
    return proto3.util.equals(ReadMaintenanceArgs, a, b);
  }
}

/**
 * UpdateMaintenanceArgs メッセージ
 *
 * @generated from message service.UpdateMaintenanceArgs
 */
export class UpdateMaintenanceArgs extends Message<UpdateMaintenanceArgs> {
  /**
   * @generated from field: repeated entity.Maintenance maintenances = 1;
   */
  maintenances: Maintenance[] = [];

  /**
   * @generated from field: bool allow_missing = 2 [json_name = "allow_missing"];
   */
  allowMissing = false;

  /**
   * @generated from field: bool force_execute = 3 [json_name = "force_execute"];
   */
  forceExecute = false;

  /**
   * @generated from field: bool skip_version_migration = 4 [json_name = "skip_version_migration"];
   */
  skipVersionMigration = false;

  constructor(data?: PartialMessage<UpdateMaintenanceArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.UpdateMaintenanceArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "maintenances", kind: "message", T: Maintenance, repeated: true },
    { no: 2, name: "allow_missing", jsonName: "allow_missing", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "force_execute", jsonName: "force_execute", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "skip_version_migration", jsonName: "skip_version_migration", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateMaintenanceArgs {
    return new UpdateMaintenanceArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateMaintenanceArgs {
    return new UpdateMaintenanceArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateMaintenanceArgs {
    return new UpdateMaintenanceArgs().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateMaintenanceArgs | PlainMessage<UpdateMaintenanceArgs> | undefined, b: UpdateMaintenanceArgs | PlainMessage<UpdateMaintenanceArgs> | undefined): boolean {
    return proto3.util.equals(UpdateMaintenanceArgs, a, b);
  }
}

/**
 * DeleteMaintenanceArgs メッセージ
 *
 * @generated from message service.DeleteMaintenanceArgs
 */
export class DeleteMaintenanceArgs extends Message<DeleteMaintenanceArgs> {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[] = [];

  /**
   * @generated from field: bool force_execute = 2 [json_name = "force_execute"];
   */
  forceExecute = false;

  constructor(data?: PartialMessage<DeleteMaintenanceArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.DeleteMaintenanceArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "force_execute", jsonName: "force_execute", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteMaintenanceArgs {
    return new DeleteMaintenanceArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteMaintenanceArgs {
    return new DeleteMaintenanceArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteMaintenanceArgs {
    return new DeleteMaintenanceArgs().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteMaintenanceArgs | PlainMessage<DeleteMaintenanceArgs> | undefined, b: DeleteMaintenanceArgs | PlainMessage<DeleteMaintenanceArgs> | undefined): boolean {
    return proto3.util.equals(DeleteMaintenanceArgs, a, b);
  }
}

/**
 * IndexMaintenanceReply メッセージ
 *
 * @generated from message service.IndexMaintenanceReply
 */
export class IndexMaintenanceReply extends Message<IndexMaintenanceReply> {
  /**
   * @generated from field: repeated entity.Maintenance maintenances = 1;
   */
  maintenances: Maintenance[] = [];

  constructor(data?: PartialMessage<IndexMaintenanceReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.IndexMaintenanceReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "maintenances", kind: "message", T: Maintenance, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IndexMaintenanceReply {
    return new IndexMaintenanceReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IndexMaintenanceReply {
    return new IndexMaintenanceReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IndexMaintenanceReply {
    return new IndexMaintenanceReply().fromJsonString(jsonString, options);
  }

  static equals(a: IndexMaintenanceReply | PlainMessage<IndexMaintenanceReply> | undefined, b: IndexMaintenanceReply | PlainMessage<IndexMaintenanceReply> | undefined): boolean {
    return proto3.util.equals(IndexMaintenanceReply, a, b);
  }
}

/**
 * CreateMaintenanceReply メッセージ
 *
 * @generated from message service.CreateMaintenanceReply
 */
export class CreateMaintenanceReply extends Message<CreateMaintenanceReply> {
  constructor(data?: PartialMessage<CreateMaintenanceReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.CreateMaintenanceReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateMaintenanceReply {
    return new CreateMaintenanceReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateMaintenanceReply {
    return new CreateMaintenanceReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateMaintenanceReply {
    return new CreateMaintenanceReply().fromJsonString(jsonString, options);
  }

  static equals(a: CreateMaintenanceReply | PlainMessage<CreateMaintenanceReply> | undefined, b: CreateMaintenanceReply | PlainMessage<CreateMaintenanceReply> | undefined): boolean {
    return proto3.util.equals(CreateMaintenanceReply, a, b);
  }
}

/**
 * ReadMaintenanceReply メッセージ
 *
 * @generated from message service.ReadMaintenanceReply
 */
export class ReadMaintenanceReply extends Message<ReadMaintenanceReply> {
  /**
   * @generated from field: repeated entity.Maintenance maintenances = 1;
   */
  maintenances: Maintenance[] = [];

  constructor(data?: PartialMessage<ReadMaintenanceReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.ReadMaintenanceReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "maintenances", kind: "message", T: Maintenance, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReadMaintenanceReply {
    return new ReadMaintenanceReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReadMaintenanceReply {
    return new ReadMaintenanceReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReadMaintenanceReply {
    return new ReadMaintenanceReply().fromJsonString(jsonString, options);
  }

  static equals(a: ReadMaintenanceReply | PlainMessage<ReadMaintenanceReply> | undefined, b: ReadMaintenanceReply | PlainMessage<ReadMaintenanceReply> | undefined): boolean {
    return proto3.util.equals(ReadMaintenanceReply, a, b);
  }
}

/**
 * UpdateMaintenanceReply メッセージ
 *
 * @generated from message service.UpdateMaintenanceReply
 */
export class UpdateMaintenanceReply extends Message<UpdateMaintenanceReply> {
  constructor(data?: PartialMessage<UpdateMaintenanceReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.UpdateMaintenanceReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateMaintenanceReply {
    return new UpdateMaintenanceReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateMaintenanceReply {
    return new UpdateMaintenanceReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateMaintenanceReply {
    return new UpdateMaintenanceReply().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateMaintenanceReply | PlainMessage<UpdateMaintenanceReply> | undefined, b: UpdateMaintenanceReply | PlainMessage<UpdateMaintenanceReply> | undefined): boolean {
    return proto3.util.equals(UpdateMaintenanceReply, a, b);
  }
}

/**
 * DeleteMaintenanceReply メッセージ
 *
 * @generated from message service.DeleteMaintenanceReply
 */
export class DeleteMaintenanceReply extends Message<DeleteMaintenanceReply> {
  constructor(data?: PartialMessage<DeleteMaintenanceReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.DeleteMaintenanceReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteMaintenanceReply {
    return new DeleteMaintenanceReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteMaintenanceReply {
    return new DeleteMaintenanceReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteMaintenanceReply {
    return new DeleteMaintenanceReply().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteMaintenanceReply | PlainMessage<DeleteMaintenanceReply> | undefined, b: DeleteMaintenanceReply | PlainMessage<DeleteMaintenanceReply> | undefined): boolean {
    return proto3.util.equals(DeleteMaintenanceReply, a, b);
  }
}

